import { FormContactSMESchema } from 'components/SMEContactForm/hooks/useFormContactSMESchema';
import { FormContactSchema } from 'components/ContactForm/hooks/useFormContactSchema';
import { ClientDetails } from 'features/utils/types';
import { getSearchParams } from 'utils/urlUtils';
import { VendorConfig } from 'store/vendor/VendorProvider';
import { AnswersState } from 'schemas/answerStateSchema';

export const getClientDetails = (
  data: FormContactSchema & FormContactSMESchema,
  answers: AnswersState,
  vendorConfig: VendorConfig,
  description: string
): ClientDetails => {
  // try to format addrss correctly
  const address = answers.address || 'unknown';
  let street = address;
  let city = address;
  let country = address;
  const postalCode = answers.addressDetails?.postCode || 'unknown';
  try {
    [street, city, country] = address.split(',');

    // be sure to remove possible postcode from city
    if (city.includes(postalCode)) {
      city = city.replaceAll(postalCode, '');
    }
    city = city.trim();
  } catch (e) {
    console.warn(`not able to split address:${e}`);
  }

  const isB2B = answers.businessChoice === 'b2b';

  return {
    department: 'PVELEC',
    workingTypes: ['PVELECPH'],
    origin: vendorConfig.origin + (isB2B ? ' SME' : ''),
    lastName: data.lastName,
    firstName: data.firstName,
    email: data.email,
    mobileNumber: data.phone,
    language: vendorConfig.language,
    city,
    street,
    country,
    postalCode,
    requestDescription: description,
    utm: getSearchParams()?.toString() || '', // TODO: refactor this to keep UTM's in the state.

    isCompany: isB2B,
    companyName: isB2B ? data.company : undefined,
    vatNumber: isB2B ? data.tva : undefined,
  };
};
